import { FolderSharingRole } from "./FolderSharing.dto";

const sharingRoles = Object.values(FolderSharingRole);

export function isSharingRoleAuthorized({
  myRole,
  role,
  exceptRole,
}: {
  myRole: FolderSharingRole;
  role: FolderSharingRole;
  exceptRole?: FolderSharingRole[];
}): boolean {
  if (!myRole) return false;

  const aIdx = sharingRoles.indexOf(myRole);
  const bIdx = sharingRoles.indexOf(role);

  if (aIdx >= bIdx) {
    if (!exceptRole || !exceptRole.includes(myRole)) {
      return true;
    }
  }

  return false;
}
